import type { InputHTMLAttributes } from 'react';
import styles from './TextInput.module.css';

interface TextInputProps extends InputHTMLAttributes<HTMLInputElement> {
  icon?: string;
}

export function TextInput({ icon, className = '', ...props }: TextInputProps) {
  return (
    <div className={styles.container}>
      {icon && <span className={styles.icon}>{icon}</span>}
      <input className={`${styles.input} ${className}`} {...props} />
    </div>
  );
}

export default TextInput;
